import React from 'react';
import SendIcon from '@material-ui/icons/Send';
import AppNavButton from './Components/AppNavButton';

const ReleaseManagementNav = () => {
	return (
		<AppNavButton text="Release Management" showGroupingMenu={true} path="/contractrelease" icon={<SendIcon />} />
	);
};

export default ReleaseManagementNav;
